import { useQuery } from '@tanstack/react-query';
import { isListEnabled } from 'utils/queryHelpers';

import { statisticsService } from 'services';
import { QueryContextFromKeys, QueryParamModel } from 'models';

type NotCompletedAfterDeadLineContexts = QueryContextFromKeys<typeof notCompletedAfterDeadlineKeys>;

export const notCompletedAfterDeadlineKeys = {
  all: [{ scope: 'notCompletedAfterDeadLine' }] as const,
  lists: () => [{ ...notCompletedAfterDeadlineKeys.all[0], entity: 'list' }] as const,
  list: (params?: QueryParamModel | null) =>
    [{ ...notCompletedAfterDeadlineKeys.lists()[0], params }] as const,
};

const fetchNotCompletedAfterDeadLineList = async ({
  queryKey: [{ params }],
}: NotCompletedAfterDeadLineContexts['list']) =>
  statisticsService.getNotCompletedAfterDeadLineList(params);

const exportNotCompletedAfterDeadLine = async ({
  queryKey: [{ params }],
}: NotCompletedAfterDeadLineContexts['list']) =>
  statisticsService.exportNotCompletedAfterDeadLineStatistics(params);

export const useNotCompletedAfterDeadLineList = (params?: QueryParamModel | null) =>
  useQuery({
    queryKey: notCompletedAfterDeadlineKeys.list(params),
    queryFn: fetchNotCompletedAfterDeadLineList,
    enabled: isListEnabled(params),
  });

export const useExportNotCompletedAfterDeadLine = (params?: QueryParamModel | null) => {
  return useQuery({
    queryKey: notCompletedAfterDeadlineKeys.list(params),
    queryFn: exportNotCompletedAfterDeadLine,
    enabled: false,
  });
};
